/* eslint no-console: ["warn", { allow: ["error"] }] */

/**
 * importPublicKey
 *
 * converts a base64-encoded publicKeyString into a CryptoKey object which can encrypt sensitive data for transport.
 */
export async function importPublicKey(publicKeyString) {
  // publicKeyString has been converted to a base64 string for transport so must be converted ito bytes then a Uint8Array.
  const decodedPublicKey = new Uint8Array(
    atob(publicKeyString)
      .split('')
      .map((char) => char.charCodeAt(0))
  );
  // Convert ArrayBuffer into a CryptoKey object.
  return crypto.subtle.importKey(
    'spki',
    decodedPublicKey.buffer,
    {
      name: 'RSA-OAEP',
      hash: { name: 'SHA-256' },
    },
    true,
    ['encrypt']
  );
}

/**
 * encryptWithPublicKey
 *
 * encrypts data with a matching CryptoKey.
 */
export async function encryptWithPublicKey(text, publicKey) {
  // Convert string into UintArray ready for encrypting.
  const encodedText = new TextEncoder().encode(text);

  const encryptedData = await crypto.subtle.encrypt(
    {
      name: 'RSA-OAEP',
    },
    publicKey,
    encodedText
  );
  // Convert encryptedBytes into a base64 string for transport.
  return btoa(String.fromCharCode(...new Uint8Array(encryptedData)));
}
